import { DispositionCode } from "../enums/DispositionCode";

export function createDispositionCode(el?: any): DispositionCode {
    if (el == null) return undefined;
    return DispositionCode[el as keyof DispositionCode];
}
